import * as Yup from 'yup'

const rejectMenuCrawlingSchema = Yup.object().shape({
  crawlingRejectedComment: Yup.string()
    .required(`Crawling rejection comment is required.`)
    .nullable(),
})

export default rejectMenuCrawlingSchema
